"use client";

export function LogoMark() {
  return (
    <div
      aria-hidden
      className="relative flex h-14 w-14 items-center justify-center"
    >
      <span
        className="absolute inset-0 rounded-full bg-emerald-100"
        style={{
          animation: "pulse 2.4s ease-in-out infinite",
          willChange: "opacity, transform",
        }}
      />
      <span className="absolute inset-1 rounded-full bg-emerald-50 ring-1 ring-emerald-200/60" />
      <img
        src="/logo.webp"
        alt=""
        className="relative h-7 w-7 object-contain"
      />
    </div>
  );
}
